import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Geography } from '../../model/paises';
import { ServicioService } from '../../services/servicio.service';
import { environment } from 'src/environments/environment';

// declare var $zopim: any;
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.page.html',
  styleUrls: ['./inicio.page.scss'],
})
export class InicioPage implements OnInit {

  public APP_VERSION = `${ environment.VERSION } 2023.11.15`

  paso = 1;

  paises = [];

  pais = 'co';

  url;

  constructor(
    private router: Router,
    private geography: Geography,
    private service: ServicioService
  ) {
    this.geography.initializePaises();
    this.paises = this.geography.paises;
  }

  ngOnInit() {
    this.pais = 'co';
  }

  ionViewDidEnter() {
    // if (this.pais !== 'co') {
    //   const waitForZopim = setInterval(() => {
    //     if ($zopim === undefined || $zopim.livechat === undefined) {
    //       return;
    //     }
    //     $zopim(() => {
    //       $zopim.livechat.window.hide();
    //     });
    //     clearInterval(waitForZopim);
    //   }, 800);
    // }

  }


  ionViewDidLeave() {
    this.url = this.router.url;
    if (this.url.includes('/inicio') || this.url === '/') {
      // this.valor.visible = true;
    }
  }

  async escogePais(pais) {
    this.pais = pais;
    this.service.setVariable('pais', pais);

    await this.service.publishCountryData({
      ev: 'changePais'
    });
  }


  continuar() {

    this.escogePais(this.pais);

    // this.router.navigateByUrl('/inicio');
    this.router.navigateByUrl('/select/' + this.pais, { replaceUrl: true });
  }



}
